var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8323 10.0197L19.6199 2.23182C20.1267 1.72525 20.1267 0.906206 19.6199 0.399639C19.1133 -0.106927 18.2943 -0.106927 17.7877 0.399639L9.99989 8.18748L2.21229 0.399639C1.70548 -0.106927 0.88667 -0.106927 0.380103 0.399639C-0.126701 0.906206 -0.126701 1.72525 0.380103 2.23182L8.16771 10.0197L0.380103 17.8075C-0.126701 18.3141 -0.126701 19.1331 0.380103 19.6397C0.632556 19.8924 0.964494 20.0193 1.29619 20.0193C1.62789 20.0193 1.9596 19.8924 2.21229 19.6397L9.99989 11.8518L17.7877 19.6397C18.0404 19.8924 18.3721 20.0193 18.7038 20.0193C19.0355 20.0193 19.3672 19.8924 19.6199 19.6397C20.1267 19.1331 20.1267 18.3141 19.6199 17.8075L11.8323 10.0197Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d4eff9a6.svg";
export { ForwardRef as ReactComponent };